import React from 'react';

function FormLabel({ color = "gray", name, text }) {
    return (
        <label
            htmlFor={name}
            className={`block text-sm font-medium leading-5 text-${color}-500 dark:text-${color == "gray"  ? "white" : color-"50"}`}
        >
            {text}
        </label>
    )
}

export default FormLabel